import mwcMarketsCore from 'mwc-markets-core';
import Portfolio from './portfolio.vue';

const { createCustomElement } = mwcMarketsCore;
createCustomElement(Portfolio);
export default Portfolio;
